import React, { FocusEventHandler } from 'react';
import clsx from 'clsx';
import Button from '@components/Button';
import { isAmountZeroEquivalent } from '@lib/utils';

interface AmountInputProps {
  className?: string;
  disableMaxButton?: boolean;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onMaxClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  value: string;
}

const AmountInput = ({
  className,
  disableMaxButton,
  onBlur,
  onChange,
  onMaxClick,
  value,
}: AmountInputProps) => {
  return (
    <div
      className={clsx(
        'flex bg-black items-center rounded-small shadow-default px-2 h-[60px]',
        className
      )}
    >
      <div className="text-white text-smallSemibold font-semibold">Amount</div>
      <input
        data-testid="amount-input"
        className="min-w-0 bg-transparent outline-none caret-white text-white text-number font-normal placeholder-white flex-1 text-right webkit-none px-3"
        inputMode="decimal"
        maxLength={15}
        minLength={1}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={(e): void => {
          if (isAmountZeroEquivalent(value)) {
            e.target.select();
          }
        }}
        pattern="^[0-9]+\.?[0-9]*$"
        placeholder="0"
        type="text"
        value={value}
      />
      <Button
        className="w-5 h-2.5"
        disabled={disableMaxButton}
        name="amount-input-max-button"
        onClick={onMaxClick}
        size="micro"
        variant="inverted"
      >
        Max
      </Button>
    </div>
  );
};

export default AmountInput;
